export default {
  'CUSTOM_LISTS' (state) {
    return state.lists
  },
  'CUSTOM_LIST' (state) {
    return state.list
  },
  'CUSTOM_LIST_ITEMS' (state) {
    return state.items
  }
}
